import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';
import { fileDownload } from '../../shared/fileDownload';

function decodeUtf8(s) {
  return decodeURIComponent(escape(s));
}

function convertBuffer(buf) {
  return decodeUtf8(String.fromCharCode.apply(null, new Uint8Array(buf)));
}

export const requestTimeClockReport = report => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/timeSheet/generate/pointSheet/report', report, {
    // .post('/pointsheet/generate/report', report, {
      responseType: 'arraybuffer',
    })
    .then((response) => {
      dispatch(setLoading(false));
      fileDownload(response.data, 'Relatório Espelho de Ponto.pdf');
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(convertBuffer(error)));
    });
};

export const requestListReport = report => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/timeSheet/generate/pointSheet/getListReport', report, {
    // .post('/pointsheet/generate/report', report, {
      responseType: 'arraybuffer',
    })
    .then((response) => {
      dispatch(setLoading(false));
      fileDownload(response.data, 'Lista de Ponto.pdf');
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(convertBuffer(error)));
    });
};

export const requestImportAfd1510Report = report => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/export/afd/records', report, {
      responseType: 'arraybuffer',
    })
    .then((response) => {
      let extension = '.txt';
      if (response.headers['content-type'] === 'application/zip') {
        extension = '.zip';
      }

      dispatch(setLoading(false));
      fileDownload(response.data, `Relatório AFD 1510${extension}`);
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(convertBuffer(error)));
    });
};

export const requestImportAfd671Report = report => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/export/afd671/records', report, {
      responseType: 'arraybuffer',
    })
    .then((response) => {
      let extension = '.txt';
      if (response.headers['content-type'] === 'application/zip') {
        extension = '.zip';
      }
      dispatch(setLoading(false));
      fileDownload(response.data, `AFD00000000926246828${localStorage.cnpj}REP_P${extension}`);

    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(convertBuffer(error)));
    });
};

export const requestImportAEJReport = report => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/export/AEJ', report, {
      responseType: 'arraybuffer',
    })
    .then((response) => {
      let extension = '.txt';
      if (response.headers['content-type'] === 'application/zip') {
        extension = '.zip';
      }
      dispatch(setLoading(false));
      fileDownload(response.data, `AEJ${localStorage.cnpj}-${extension}`);

    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(convertBuffer(error)));
    });
};

export const requestLocationReport = report => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/timeSheet/generate/pointSheet/locations/report', report, {
    // .post('/report/web/pointSheetWithLocations', report, {
      responseType: 'arraybuffer',
    })
    .then((response) => {
      dispatch(setLoading(false));
      fileDownload(response.data, 'Relatório Pontos com Localização.pdf');
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(convertBuffer(error)));
    });
};

export const requestPhotoReport = report => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .post('/timeSheet/generate/pointSheet/photos/report', report, {
    // .post('/report/web/pointSheetWithPhotos', report, {
      responseType: 'arraybuffer',
    })
    .then((response) => {
      dispatch(setLoading(false));
      fileDownload(response.data, 'Relatório Pontos com Foto.pdf');
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const requestAbsenceReport = report => (dispatch) => {
  dispatch(setLoading(true));
  axios
    // .post('/report/web/absencesByPeriod', report, {
    .post('https://api.puntu.digital/timeSheet/generate/pointSheet/absences/report', report, {
      responseType: 'arraybuffer',
    })
    .then((response) => {
      dispatch(setLoading(false));
      fileDownload(response.data, 'Relatório Faltas.pdf');
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};
